import React, { useContext } from 'react';
// import useStyles from '@front10/helpers/dist/UseStyles';
import { StyleProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import { getRelativeDateLocalization } from '../../../helpers/localization/localizationUtils';

import Box from '../../elements/Box';
import Text from '../../elements/Text';
import { useEffect } from 'react';

interface onClickProps {
  type: string;
  date: Date;
}

const keyPress: $TSFixMe = {
  ArrowLeft: 'ARROW_LEFT',
  ArrowUp: 'ARROW_UP',
  ArrowRight: 'ARROW_RIGHT',
  ArrowDown: 'ARROW_DOWN'
  // PageDown: 'PageDown',
  // PageUp: 'PREV_MONTH',
  // Home: 'BEGINS_WEEK',
  // End: 'END_WEEK'
};

export interface DateControlProps {
  labelKey: string;
  date: Date;
  suggestedData: any;
  dateFormat: string;
  disabled: boolean;
  suggestedDateFormat: string;
  labelSettings: StyleProps;
  dateSettings: StyleProps;
  dateSettingsWithoutValue: StyleProps;
  infoSuggestedSettings: StyleProps;
  showSuggested: boolean;
  suggestedFirstTextSettings: StyleProps;
  suggestedFirstTextLabelKey: string;
  suggestedButtonTextSettings: StyleProps;
  suggestedSecondTextSettings: StyleProps;
  suggestedSecondTextLabelKey: string;
  containerSettings: StyleProps;
  containerSelectedSettings: StyleProps;
  onClickSuggestedDate?: (suggestedDate: Date) => void;
  onClick?: (item: onClickProps) => void;
  handleDate?: (action: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: (e: any, date: Date) => void;
  isMobile?: boolean;
  isSelected?: boolean;
  focusClass?: string;
}

function DateControl(
  {
    date,
    dateFormat = 'MMM D, YYYY',
    suggestedData,
    suggestedDateFormat = 'D MMM YYYY',
    disabled = false,
    labelKey = 'departure',
    labelSettings = {},
    dateSettings = {},
    dateSettingsWithoutValue = { marginLeft: '48px' },
    infoSuggestedSettings = {},
    showSuggested = false,
    suggestedFirstTextSettings = {},
    suggestedFirstTextLabelKey = 'cmp-date-control-suggested-try',
    suggestedButtonTextSettings = {},
    suggestedSecondTextSettings = {},
    suggestedSecondTextLabelKey = 'cmp-date-control-suggested-description',
    containerSettings = {},
    onClickSuggestedDate = () => {},
    onClick = () => {},
    handleDate = () => {},
    onFocus = () => {},
    onBlur = () => {},
    isMobile = false,
    isSelected,
    focusClass,
    containerSelectedSettings,
    onKeyDown = () => {},
    ...rest
  }: DateControlProps,
  ref: any
) {
  const {
    translate,
    // direction,
    // theme,
    localizationData,
    moment: ingloriousMomentNeverUseMe
  } = useContext(Context);
  // const [className, style] = useStyles(rest, { direction, theme });
  const relativeTime = getRelativeDateLocalization(translate, localizationData);
  ingloriousMomentNeverUseMe.locale(relativeTime.name, relativeTime);

  const [handleKeyActive, setHandleKey] = React.useState(false);
  const [shiftKeyPress, setShiftKeyPress] = React.useState(false);
  const containerRef = React.useRef<$TSFixMe>(null);

  const handleKeydown = (e: React.KeyboardEvent) => {
    onKeyDown(e, date);
    if (e.key !== 'Tab' && keyPress[e.key]) {
      e.preventDefault();
      handleDate(keyPress[e.key]);
    }
    setShiftKeyPress(e.shiftKey);
  };

  const handleClick = () => {
    if (handleKeyActive) {
      document.addEventListener('click', handleOutsideClick, false);
    } else {
      document.removeEventListener('click', handleOutsideClick, false);
    }
    onClick({ type: labelKey, date });
  };

  const handleOutsideClick = (e: $TSFixMe) => {
    if (containerRef.current?.contains(e.target)) {
      return;
    }
    setHandleKey(false);
  };

  React.useImperativeHandle(ref, () => ({
    focus: () => {
      containerRef.current.focus();
    },
    onClick: handleClick
  }));

  useEffect(() => {
    if (isSelected) {
      containerRef?.current?.classList.add(focusClass || 'fr-focus:focus');
    } else {
      containerRef?.current?.classList.remove(focusClass || 'fr-focus:focus');
    }
  }, [focusClass, isSelected]);

  const newContainerSettings = isSelected ? containerSelectedSettings : containerSettings;

  const finalDateSettings = {
    ...dateSettings,
    ...(!Boolean(date) ? dateSettingsWithoutValue : null)
  };

  return (
    <>
      <Box
        {...newContainerSettings}
        className={`${disabled ? 'fr-disabled' : ''}`}
        focusReferences={containerRef}
        onFocus={() => {
          if (onFocus) {
            onFocus();
          }
          setHandleKey(true);
        }}
        onBlur={() => {
          if (!showSuggested) {
            setHandleKey(false);
          }
          if (shiftKeyPress) {
            setHandleKey(false);
          }
          if (onBlur) {
            onBlur();
          }
        }}
        onClick={handleClick}
        onKeyDown={handleKeydown}
      >
        <Text {...labelSettings}>{translate(`cmp-date-control-${labelKey}`, labelKey)}</Text>

        <Text {...finalDateSettings}>
          {Boolean(date) && !disabled
            ? ingloriousMomentNeverUseMe(date).format(dateFormat)
            : translate('cmp-separator-minus', '--')}
        </Text>
      </Box>
      {/* {!isMobile && showSuggested && !disabled && suggestedData !== null && (
        <Box {...infoSuggestedSettings}>
          <Text {...suggestedFirstTextSettings}>
            {translate(suggestedFirstTextLabelKey, 'Try')}
          </Text>

          <Button
            onBlur={() => setHandleKey(false)}
            role="link"
            {...suggestedButtonTextSettings}
            onClick={() => onClickSuggestedDate(suggestedData.date)}
          >
            {ingloriousMomentNeverUseMe(suggestedData.date).format(suggestedDateFormat)}
          </Button>

          <Text {...suggestedSecondTextSettings}>
            {translate(
              suggestedSecondTextLabelKey,
              `for lowest fare of  ${suggestedData.currencyCode}  ${suggestedData.price}* in the next 30 days`
            )}
          </Text>
        </Box>
      )} */}
      {/* <VisuallyHidden role="status">
        {showSuggested
          ? `${translate(suggestedFirstTextLabelKey, 'Try')} ${ingloriousMomentNeverUseMe(
              suggestedData.date
            ).format(suggestedDateFormat)} ${translate(
              suggestedSecondTextLabelKey,
              `for lowest fare of  ${suggestedData.currencyCode}  ${suggestedData.price}* in the next 30 days`
            )}`
          : ''}
      </VisuallyHidden> */}
    </>
  );
}

export default React.forwardRef(DateControl);
